import {
  post
} from '@get/http.js'
export const getClassList = (data) => {

  return post('/lw.XiaoetGoods/getList', {
    data
  })
}